export const TimeframeEnum = {
  Today: "Today",
  Yesterday: "Yesterday",
  ThisWeek: "ThisWeek",
  LastWeek: "LastWeek"
};
